module.exports = __webpack_public_path__ + "static/img/bh.c3102980.svg";